import type { Automation } from '../api/types';

/** UI-34: the automations that fire on a piece of media: comment ones for posts and reels, story-reply ones for stories. */
export function automationsForMedia(
  automations: readonly Automation[],
  externalId: string,
  kind: 'story' | 'feed',
): Automation[] {
  const trigger = kind === 'story' ? 'story_reply' : 'comment';
  return automations.filter(
    (a) =>
      a.triggerType === trigger &&
      (a.mediaBinding.kind === 'any' || a.mediaBinding.mediaIds.includes(externalId)),
  );
}
